
<style scoped>
.warp {
  width: 100%;
  background: black;
  height: 200px;
}
.header {
  width: 100%;
  margin-top: 10px;
  display: flex;
}
.header_left {
  width: 140px;
  height: 234px;
  background: #721a18;
  padding: 0 10px;
}
.header_nav {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
}
.header_nav:last-child {
  border-bottom: none;
}
.header_icon {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-radius: 8px;
}
.header_title {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  margin-left: 15px;
}
.header_bg {
  width: 980px;
  height: 234px;
}
.header_bg img {
  width: 100%;
  height: 100%;
}
.content {
  margin-top: 10px;
  width: 100%;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #f5f5f5;
}
.content_title {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  padding-left: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f2f2f2;
}
.content_line {
  width: 104px;
  height: 2px;
  background: #e53631;
  margin-top: -2px;
}
.content_box {
}
/* main */
.main {
  width: 540px;
  height: 88px;
  background: #f9f9f9;
  border-radius: 2px;
  margin-top: 10px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main_left {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.main_top {
  display: flex;
}
.main_txt {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.main_icon {
  padding: 1px 2px;
  font-size: 14px;
  color: #e53631;
  background: #ffe6e5;
  border-radius: 2px;
  margin-left: 5px;
}
.main_bot {
  font-size: 16px;
  color: #999999;
  line-height: 16px;
  margin-top: 15px;
}
.main_right {
  width: 100px;
  font-size: 20px;
  font-weight: 600;
  color: #e53631;
  line-height: 20px;
}
</style>

<template>
  <div class="home">
    <div class="header">
      <div class="header_left">
        <div class="header_nav"
             v-for="item in navArr"
             :key="item.id"
             @click="toPage(item.name)">
          <div class="header_icon"></div>
          <span class="header_title">{{item.title}}</span>
        </div>
      </div>
      <div class="header_bg">
        <img src="@/assets/img/home_bg.png"
             alt="">
      </div>
    </div>
    <div class="content">
      <p class="content_title">最新兼职</p>
      <div class="content_line"></div>
      <div class="content_box">
        <el-row :gutter="10">
          <el-col :span="12"
                  v-for="item in infoArr"
                  :key="item.jobCode">
            <info :item="item"></info>
            <!-- <div class="main">
              <div class="main_left">
                <div class="main_top">
                  <div class="main_txt">{{item.title}}</div>
                  <div class="main_icon"
                       v-for="txt in item.tag.split(',').slice(0,2) "
                       :key="txt">{{txt}}</div>
                </div>
                <p class="main_bot">{{item.companyName}}</p>
              </div>
              <div class="main_right">{{item.salary}}</div>
            </div> -->
          </el-col>
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
import info from '@/components/info'

export default {
  components: {
    info,
  },
  data () {
    return {
      navArr: [
        {
          id: 0,
          title: '短期招工',
          name: 'shortTerm'
        },
        {
          id: 1,
          title: '高薪日结',
          name: 'highPay'
        }, {
          id: 2,
          title: '周末兼职',
          name: "weekendPart"
        }, {
          id: 3,
          title: '食宿全包',
          name: 'inclusive'
        },
      ],
      infoArr: [],
      tagArr: []
    }
  },
  created () {
    this.getInfo();
  },
  methods: {
    toPage (page) {
      this.$router.push({ name: page });
    },
    getInfo () {
      this.$get("/app/api/v1/verify/index", { jobType: 1 })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.infoArr = res.data;
            this.tagArr = this.infoArr[0].tag.split(',');
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
  },
}
</script>
